import React, { useState } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Exclusively() {
    const data = [
        { id: 1, btn:"EXPLORE",  url:"/corporate", img: "/images/home/corporate-slider.jpg",para:"Host impactful conferences and corporate events with seamless sophistication", title: "CORPORATE" },
        { id: 2, btn:"EXPLORE",  url:"/corporate#mebership", img: "/images/home/membership.jpg",para:"Enjoy special discounts on corporate events and conferences with your tiered membership.", title: "MEMBERSHIP" },
        { id: 2, btn:"QUERY ",  url:"/banquet-query", img: "/images/home/BANQUETS.jpg",para:"Celebrate in style with marble-finished grandeur and golden accents.", title: "MEETING ROOM" },
        { id: 3, btn:"DINING" , url:"/dining", img: "/images/dine/dine-1/dine-1-3.jpg",para:"Enter a realm of storied halls, sophisticated delights and unrivalled indulgence. Immerse yourself in the grandeur of luxury at our exquisite palaces, hotels, resorts and safaris.", title: "DINING" },
       
      ];
      const settings = {
        dots: false, // Dots indicators
        infinite: true, // Infinite scroll
        speed: 1200,
        slidesToShow: 1, // 3 cards in one row
        slidesToScroll: 1, // Scroll by 1 card
        autoplay: false, // Auto scroll
        autoplaySpeed: 5000, // 2 sec per slide
        arrows: true, // Left/Right arrows
        responsive: [
          {
            breakpoint: 768, // Mobile screen
            settings: {
              slidesToShow: 1, // Show 1 card on mobile
            }
          }
          ,
        
        ]
      };
  return (
   <>
   {/* Meta Tags for SEO */}
            <Helmet>
                <title> V Hotel The Grand Shoba - Exclusive Events & Offers </title>
                <meta name="description" content="Explore our exclusive corporate events, membership offers, banquets, and dining experiences at V Hotel The Grand Shoba near Delhi Airport." />
                <meta property="og:title" content="Exclusive Events & Offers - V Hotel The Grand Shoba" />
                <meta property="og:description" content="Book corporate events, membership discounts, and indulge in world-class dining at V Hotel The Grand Shoba. Explore more." />
                <meta property="og:image" content="images/home/corporate-slider.jpg" />
            </Helmet>



   <div className="explore-main " style={{ backgroundImage: "url('/images/home/corporate-bg.jpg')",backgroundSize: "cover" }}>
   <div className="container ex-co ">
    <div className="container-fluid">
       <div className="row">

         <div className="col-md-12">
            <div className="explore ">
              <div className='explore-left'>
             <div className="exl-under"></div> 
              <h1>CORPORATE/</h1>
               <span> EVENTS</span>
            </div>
            <div className="explore-right">
                <p>Elegance meets purpose across corporate halls, events, and fine dining.</p>
            </div>
            </div>


            <div className="carousel-container-2 ">
     {/* <div className="col-12"> */}
     <Slider {...settings}>
        {data.map((item) => {
          return(
            <>
             <div key={item.id} className="card-2 me-1">
            <img src={item.img} alt={"V Hotel The Grnad Shoba"+item.title} title={`V Hotel The Grnad Shoba-Event/Corporate`} />
            <h3>{item.title}</h3>
            <p>{item.para}</p>
             <Link to={item.url} >{item.btn} &gt;</Link>
            
            
          </div>
            </>
          )
        })}
      </Slider>
     </div>

         </div>
         
    {/* slider */}
    

        </div>  
      
    </div>
   </div>
   </div>
   </>
  )
}


